import createVueComponent from '../createVueComponent';

const Check = createVueComponent('CheckIcon', [
  ['polyline', { points: '20 6 9 17 4 12', key: '10jjfj' }],
]);

export default Check;
